import Container from '@mui/material/Container';
import Skeleton, { SkeletonProps } from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import { FC } from 'react';

type ColumnGraphSkeletonProps = {
  animation?: SkeletonProps['animation'];
};

export const ColumnGraphSkeleton: FC<ColumnGraphSkeletonProps> = (props) => {
  const { animation } = props;

  const barHeights = [121, 241, 145, 159, 159, 112, 181, 181, 195, 195, 171, 93];

  return (
    <Container>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-end"
        useFlexGap
        spacing={10}
      >
        {barHeights.map((h, i) => {
          return (
            <Skeleton
              key={`bar-skeleton-${i}`}
              variant="rectangular"
              animation={animation}
              width={66}
              height={h}
            />
          );
        })}
      </Stack>
      <Skeleton animation={animation} height="1.2em" sx={{ marginTop: 4 }} />
    </Container>
  );
};
